import React from "react";
import { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { LoggedInAuthRoutes } from "../features/auth/routes";
import TeacherDashboard from "../features/TeacherDashboard";
import StudentDashboard from "../features/StudentDashboard";
import { AccountRoutes } from "../features/account/routes";
import { SchoolRoutes } from "../features/school/routes";
import { QuestionRoutes } from "../features/question/routes";
import { PrivateAssignmentRoutes } from "../features/assignment/routes";
import { AdministratorRoutes } from "../features/administrator/routes";
import { SuperuserRoutes } from "../features/superuser/routes";
import { PersonalisationRoutes } from "../features/personalisation/routes";
import { PrivateQuizRoutes } from "../features/quiz/routes";
import { ModeratorRoutes } from "../features/moderator/routes";
import { AssistantRoutes } from "../features/assistant/routes";
import { SchoolGroupUserRoutes } from "../features/schoolGroupUser/routes";

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <h1>Loading from protected...</h1>
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const getSubscribedRoutes = (activeContext = {}) => {
  const roleBasedRoutes = [];

  const { contextType, roleAssignment } = activeContext || {};

  if (contextType === "superuser") {
    roleBasedRoutes.push({
      path: "/superuser/*",
      element: <SuperuserRoutes />,
    });
    roleBasedRoutes.push({
      path: "/",
      element: <Navigate to="/superuser/home" />,
    });
  }

  if (contextType === "role_assignment") {
    if (roleAssignment.role.code === "admin") {
      roleBasedRoutes.push({
        path: "/management/*",
        element: <AdministratorRoutes />,
      });
      roleBasedRoutes.push({
        path: "/",
        element: <Navigate to="/management/home" />,
      });
      roleBasedRoutes.push({
        path: "/assignments/*",
        element: <PrivateAssignmentRoutes />,
      });
    }

    if (roleAssignment.role.code === "director_of_learning") {
      roleBasedRoutes.push({
        path: "/schoolGroup/*",
        element: <SchoolGroupUserRoutes />,
      });
      roleBasedRoutes.push({ path: "/school/*", element: <SchoolRoutes /> });
      roleBasedRoutes.push({
        path: "/assignments/*",
        element: <PrivateAssignmentRoutes teacher />,
      });
      roleBasedRoutes.push({
        path: "/quizzes/*",
        element: <PrivateQuizRoutes teacher />,
      });
      roleBasedRoutes.push({
        path: "/",
        element: <Navigate to="/schoolGroup/home" />,
      });
    }

    if (roleAssignment.role.code === "teacher") {
      roleBasedRoutes.push({ path: "/school/*", element: <SchoolRoutes /> });
      roleBasedRoutes.push({
        path: "/questions/*",
        element: <QuestionRoutes />,
      });
      roleBasedRoutes.push({
        path: "/assignments/*",
        element: <PrivateAssignmentRoutes teacher />,
      });
      roleBasedRoutes.push({
        path: "/personalisation/*",
        element: <PersonalisationRoutes />,
      });
      roleBasedRoutes.push({
        path: "/assistant/*",
        element: <AssistantRoutes />,
      });
      roleBasedRoutes.push({
        path: "/quizzes/*",
        element: <PrivateQuizRoutes teacher />,
      });
      roleBasedRoutes.push({ path: "/", element: <TeacherDashboard /> });
    }
    if (roleAssignment.role.code === "student") {
      roleBasedRoutes.push({ path: "/", element: <StudentDashboard /> });
      roleBasedRoutes.push({
        path: "/assignments/*",
        element: <PrivateAssignmentRoutes student />,
      });
      roleBasedRoutes.push({
        path: "/quizzes/*",
        element: <PrivateQuizRoutes student />,
      });
    }
  }

  if (contextType === "fruitify_moderator") {
    roleBasedRoutes.push({
      path: "/moderator/*",
      element: <ModeratorRoutes />,
    });
    roleBasedRoutes.push({
      path: "/",
      element: <Navigate to="/moderator/dashboard" />,
    });
  }

  return [
    {
      path: "/",
      element: <App />,
      children: [
        { path: "/auth/*", element: <LoggedInAuthRoutes /> },
        { path: "/account/*", element: <AccountRoutes /> },
        ...roleBasedRoutes,
        { path: "*", element: <Navigate to="." /> },
      ],
    },
  ];
};

export const unsubscribedRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/auth/*",
        element: <LoggedInAuthRoutes />,
      },
      { path: "/account/*", element: <AccountRoutes /> },
      { path: "/", element: <Navigate to="/account/subscriptions" /> },
      { path: "*", element: <Navigate to="." /> },
    ],
  },
];
